import BaseComponent from './BaseComponent';
import { VictoryChart, VictoryTheme, VictoryLine, VictoryAxis } from 'victory';

class ArticleChart extends BaseComponent {

	render() {
		return (
			<VictoryChart
				theme={VictoryTheme.grayscale}
				width={700}
				height={400}
				margin={0}
			>
				{/* Y Axis */}
				<VictoryAxis dependentAxis
				
					//domain={{y: [0,250,500,750,1000,1250,1500,1750,2000]}}
					tickFormat={(t) => `${Math.round(t)}`}
					style={{
						axis: {
							stroke: 'black',
							color: 'grey'
						},
						ticks: {
							stroke: 'blue',
							color: 'grey'
						},
						tickLabels: {
							color: 'grey',
							fill: 'black'
						},
						grid: {stroke: 'grey', strokeWidth: 0.3, strokeDasharray: 6},
					}}
					standalone={false}
				/>

				{/* X Axis */}
				 <VictoryAxis
					standalone={false}
					style={{
					axis: {
						stroke: 'black',
					},
					tickLabels: {
						marginTop:50,
						angle: -60,
						pading: {top: 50}
					  },
					grid: {stroke: 'grey', strokeWidth: 0.3, strokeDasharray: 6},
					fixLabelOverlap:true
					}}
				/>
				{/* Linea de evolucion de ventas */}
				<VictoryLine
				style={{
					data: { stroke: "#1F73E7" },
					
				  }}
				  	categories={{ x: this.props.labels?this.props.labels:[] }}
					data={this.props.data?.evolution?.map((dat, count) => {
						return {x: (count+1), y: dat}
					})}
				/>
				{/* Linea horizontal de precio de compra */}
				<VictoryLine
				style={{
					data: { stroke: "#b0b0b0",
						strokeWidth: 3,
						strokeDasharray: 10
					}
				  }}
					data={this.props.data?.evolution?.map((dat, count) => {
						return {x: (count+1), y: this.props.data.price}
					})}
				/>

			</VictoryChart>
		)
	}
}

export default ArticleChart;
